import { appNavigation } from "../../styles/appNavigation";
import IconHelper from "./IconHelper";

const FinanceIcon = (props) => (
  <IconHelper {...props} defaultWidth={24} defaultHeight={24}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3947 5.66479V3.53762C12.3947 3.17614 12.1017 2.88311 11.7402 2.88311H11.2084M12.3947 5.66479H9.20398C8.61765 5.73297 7.44498 6.22931 7.44498 7.66923C7.44498 9.10916 8.61765 9.46915 9.20398 9.46915H12.3947M12.3947 5.66479C12.711 5.66479 12.9674 5.92119 12.9674 6.23749V8.89645C12.9674 9.21274 12.711 9.46915 12.3947 9.46915M11.2084 2.88311V0.982148C11.2084 0.555863 10.8074 0.243339 10.394 0.34746L0.327148 2.88311V12.0054C0.327148 12.3669 0.620184 12.6599 0.981661 12.6599H11.7402C12.1017 12.6599 12.3947 12.3669 12.3947 12.0054V9.46915M0.327148 2.88311H11.2084"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1"
      />
      <circle
        cx="9.4904"
        cy="7.8737"
        r="0.327257"
        fill={"none"}
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="0.5"
      />
    </svg>
  </IconHelper>
);

export default FinanceIcon;
